export default __webpack_public_path__ + "static/media/511.68468d7a.png";